module.exports = __webpack_public_path__ + "img/moni.d35bbd6e.png";